import React from "react"
import {
    Dialog,
    DialogContent,
} from "@mui/material"
import AddOnsContent from "./AddOnsContent"

const AddOnsViewModal = ({ open, onClose, item }) => {
    if (!item) return null

    return (
        <Dialog 
            className="add-ons-container" 
            open={open} 
            onClose={onClose} 
            maxWidth="xs" 
            fullWidth 
            PaperProps={{ sx: { borderRadius: '20px', padding: '10px', color: 'black' } }}
        >
            <DialogContent sx={{
                p: 0, "&::-webkit-scrollbar": {
                    width: 0,
                    height: 0,
                }, msOverflowStyle: "none", scrollbarWidth: "none",
            }}
            >
                <AddOnsContent
                    item={item}
                    onClose={onClose}
                    viewOnly={true}
                />
            </DialogContent>
        </Dialog>
    )
}

export default AddOnsViewModal
